import api from '@/services/api';
import { prepareQueryString } from './util';

const BASE_URL = '/skin-regimen';

export default {
  getSkinRegimenPagination(params) {
    const query = prepareQueryString(params);
    return api.get(`${BASE_URL}/?${query}`);
  },
  countSkinRegimen(params) {
    const query = prepareQueryString(params);
    return api.get(`${BASE_URL}/count?${query}`);
  },
  findNextIndex(params) {
    const query = prepareQueryString(params);
    return api.get(`${BASE_URL}/next-index?${query}`);
  },
  createSkinRegimen(payload) {
    return api.post(`${BASE_URL}/`, payload);
  },
  updateSkinRegimen(id, payload) {
    return api.put(`${BASE_URL}/${id}`, payload);
  },
  findById(id) {
    return api.get(`${BASE_URL}/${id}`);
  },
};
